const brandConfig = {
  default: {
    logo: '/logo.svg',
    flag: '/usa-flag.svg',
    hero: '/usa.jpg',
    termsAndConditionsRoute: '/terms-and-conditions',
    privacyPolicyRoute: '/privacy-policy',
    country: 'usa'
  },
  'mevuelo.mx': {
    logo: '/logo.svg',
    flag: '/mexico-flag.svg',
    hero: '/mexico.jpg',
    termsAndConditionsRoute: '/terminos-y-condiciones',
    privacyPolicyRoute: '/politicas-de-privacidad',
    country: 'mexico'
  },
  'mevuelo.cl': {
    logo: '/logo.svg',
    flag: '/chile-flag.svg',
    hero: '/chile.jpg',
    termsAndConditionsRoute: '/terminos-y-condiciones',
    privacyPolicyRoute: '/politicas-de-privacidad',
    country: 'chile'
  },
  'voomeu.com': {
    logo: '/voomeu.svg',
    flag: '/brazil-flag.svg',
    hero: '/brasil.jpg',
    termsAndConditionsRoute: '/termos-e-condicoes',
    privacyPolicyRoute: '/politica-de-privacidade',
    country: 'brazil'
  },
  'mevuelo.com.ar': {
    logo: '/logo.svg',
    flag: '/argentina-flag.svg',
    hero: '/argentina.jpg',
    termsAndConditionsRoute: '/terminos-y-condiciones',
    privacyPolicyRoute: '/politicas-de-privacidad',
    country: 'argentina'
  },
  'mevuelo.com.es': {
    logo: '/logo.svg',
    flag: '/espana-flag.svg',
    hero: '/espana.jpg',
    termsAndConditionsRoute: '/terminos-y-condiciones',
    privacyPolicyRoute: '/politicas-de-privacidad',
    country: 'espana'
  },
  'volamio.com': {
    logo: '/volamio.svg',
    flag: '/italia-flag.svg',
    hero: '/italia.jpg',
    termsAndConditionsRoute: '/termini-e-condizioni',
    privacyPolicyRoute: '/informativa-sulla-privacy',
    country: 'italia'
  },
  'mevuelo.com.pe': {
    logo: '/logo.svg',
    flag: '/peru-flag.svg',
    hero: '/peru.jpg',
    termsAndConditionsRoute: '/terminos-y-condiciones',
    privacyPolicyRoute: '/politicas-de-privacidad',
    country: 'peru'
  }
};

export default brandConfig;
